import styled from "styled-components";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaIdCard, FaListAlt, FaUtensils, FaLaptopCode, FaStethoscope, FaChartLine } from "react-icons/fa";


const btnVariants = {
  hidden: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 1.6 }},
  visible: { opacity: 1, y: 0  },
};


export default function SolucionesParaTodos() {
  const { t } = useTranslation();

  const servicios = [
    {
      icon: <FaIdCard />,
      title: t("soluciones.tarjeta"),
      desc: t("soluciones.tarjeta_desc"),
      link: "https://reddigitalcreations.com/Red-Digital/",
    },
    {
      icon: <FaListAlt />,
      title: t("soluciones.catalogo"),
      desc: t("soluciones.catalogo_desc"),
      link: "https://hiblindsags.com/",
    },
    {
      icon: <FaUtensils />,
      title: t("soluciones.menu"),
      desc: t("soluciones.menu_desc"),
      link: "https://suizos-pizza.com/",
    },
    {
      icon: <FaLaptopCode />,
      title: t("soluciones.web"),
      desc: t("soluciones.web_desc"),
    },
    {
      icon: <FaStethoscope />,
      title: t("soluciones.doctores"),
      desc: t("soluciones.doctores_desc"),
    },
    {
      icon: <FaChartLine />,
      title: t("soluciones.gestion"),
      desc: t("soluciones.gestion_desc"),
    },
  ];

  return (
    <Section id="soluciones">
      <Title>{t("soluciones.titulo")}</Title>
      <Grid>
        {servicios.map((s, index) => (
          <Card
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.15 }}
          >
            <IconWrapper>{s.icon}</IconWrapper>
            <CardTitle>{s.title}</CardTitle>
            <CardDesc>{s.desc}</CardDesc>
            { s.link && (
              <a href={s.link} target="_blank" rel="noopener noreferrer">
              <ExampleButton
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
            {t("soluciones.ver_ejemplo")}
    </ExampleButton>
  </a>
)}
          </Card>
        ))}
      </Grid>
      <CTAButton
        variants={btnVariants}
        initial="hidden"
        animate="whileInView"
        whileHover={{ scale: 1.1, transition: { duration: 0.2 } }} 
        whileTap={{ scale: 0.95, transition: { duration: 0.1 } }}  
        onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
      >
        {t("soluciones.boton")}
      </CTAButton>
    </Section>
  );
}
const Section = styled.section`
  background-color: #0d0d0d;
  padding: 4rem 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const Title = styled.h2`
  color: #ff4c4c;
  font-size: 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  width: 100%;
`;

const Card = styled(motion.div)`
  background-color: #1a1a1a;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 0 10px rgba(255, 76, 76, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border: 2px solid transparent;
  transition:  background .4s, border 1s;

   @media(min-width: 1024px) {
    cursor: pointer;
      &:hover {
        background-color:rgb(15, 15, 15);
        border: 2px solid #ff0f0f;
        }
       
    }
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: #ff4c4c;
`;

const CardTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: bold;
  color: #fff;
`;

const CardDesc = styled.p`
  color: #ccc;
  font-size: 0.95rem;
`;

const CTAButton = styled(motion.button)`
  margin-top: 2rem;
  padding: 0.75rem 1.5rem;
  background-color: #e63946;
  color: white;
  font-size: 1rem;
  border-radius: 0.5rem;
  transition: background-color 0.3s;
  cursor: pointer;
  border: none;
`;
const ExampleButton = styled(motion.button)`
  margin-top: 0.5rem;
  background-color: transparent;
  border: 1px solid #ff4c4c;
  color: #ff4c4c;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;

  
  @media(min-width: 1024px) {
      &:hover {
      background-color: #ff4c4c;
      color: #fff;
    }
  }
`;